module.exports = __webpack_public_path__ + "img/2f_r_koichiro@2x.94f6c13d.jpg";